// 色瓜网 · 演示用静态数据（虚构题材，不指向真实人物/事件，仅用于页面展示）
export const siteInfo = {
  name: "色瓜网",
  slogan: "看大瓜 · 追内幕 · 捋清每一条劲爆消息的来龙去脉",
  updatedAt: "2026-09-05",
  liveCount: 12,
};

export const topTags = [
  { id: "t1", label: "最新爆料", icon: "ri-flashlight-fill" },
  { id: "t2", label: "全网热榜", icon: "ri-fire-fill" },
  { id: "t3", label: "深度挖掘", icon: "ri-search-line" },
  { id: "t4", label: "网友吵翻", icon: "ri-chat-3-fill" },
  { id: "t5", label: "进展追踪", icon: "ri-time-line" },
];

export interface FeedItem {
  id: string;
  tag: string;
  title: string;
  excerpt: string;
  meta: string;
  time: string;
  heat: string;
  trend: string;
  dir: number;
  cover?: string;
}

export const feedItems: FeedItem[] = [
  {
    id: "c1",
    tag: "今日头瓜",
    title: "年度品牌联名发布会现场翻车：预告片被网友逐帧扒出 12 处拼接痕迹",
    excerpt:
      "一场被宣发部门预热了整整两周的跨界联名，在直播开场三分钟后就被弹幕刷成了大型考古现场。事后来看，翻车的不是产品本身，而是那支号称“一镜到底”的预告片——网友用逐帧对比的方式，把镜头切换、灯光断层与道具穿帮逐一列了出来，一条条对得上号。",
    meta: "发布会现场 · 弹幕考古",
    time: "09-05 21:40",
    heat: "38.6万",
    trend: "+18%",
    dir: 1,
  },
  {
    id: "c2",
    tag: "行业暗战",
    title: "两家新茶饮同一天上新，配料表却被发现高度雷同，谁先抄谁各执一词",
    excerpt:
      "同赛道两家的上新时间撞在一天，紧接着便是粉丝之间的“谁先谁后”大战。真正的猛料不在嘴上，而在纸面上：一份被晒出的供应链单据，让舆论从口水战转成了逐条对比配料表。",
    meta: "供应链单据 · 时间线对比",
    time: "09-05 19:02",
    heat: "21.3万",
    trend: "+9%",
    dir: 1,
  },
  {
    id: "c3",
    tag: "综艺台前幕后",
    title: "录了三季的慢综艺被曝“连熬夜镜头都是演的”，导演组深夜回应",
    excerpt:
      "一句“我们只拍真实反应”的导演组宣言，被一段幕后花絮彻底击穿。花絮里工作人员举着提词板、补光团队排着队进棚——原来观众以为的“意外反应”，多数是预设好的流程。",
    meta: "幕后花絮 · 网友实锤",
    time: "09-05 16:27",
    heat: "17.8万",
    trend: "+6%",
    dir: 1,
  },
  {
    id: "c4",
    tag: "口碑反转",
    title: "三年前被全网骂停的旧番剧重新上架，评分三天从 2.1 爬到 8.4",
    excerpt:
      "当平台悄悄把一部因争议下架的旧番重新上架，谁也没想到舆论会完成一次彻底的反转。新观众把当年的“黑料”一集集看完，得出与当年完全相反的结论。",
    meta: "旧番重映 · 口碑复盘",
    time: "09-05 14:11",
    heat: "13.9万",
    trend: "+12%",
    dir: 1,
  },
  {
    id: "c5",
    tag: "内部流言",
    title: "某大厂新项目组连夜改名换脸，疑似内部重组前兆，脉脉已吵上热榜",
    excerpt:
      "一个平平无奇的项目组改名通知，却因为“连夜”、“全员”、“保密”三个词，被在职与离职员工一起送上热榜。爆料有限，但猜测无限。",
    meta: "内部通知 · 职场讨论",
    time: "09-05 11:48",
    heat: "11.2万",
    trend: "-2%",
    dir: -1,
  },
  {
    id: "c6",
    tag: "消费维权",
    title: "千元耳机“降噪翻车”视频刷屏，博主用一台旧示波器做了硬核实测",
    excerpt:
      "当玄学营销撞上硬核测评，翻车几乎是必然。博主没有停留在吐槽，而是把降噪曲线、频响表现一项项测了出来，给出了一份全网可复现的实测报告。",
    meta: "硬核实测 · 数据可复现",
    time: "09-05 09:33",
    heat: "9.7万",
    trend: "+21%",
    dir: 1,
  },
];

export const hotRank: { id: string; rank: string; title: string; keyword: string; heat: string; rise: boolean }[] = [
  { id: "r1", rank: "01", title: "联名发布会预告片“一镜到底”被逐帧拆穿", keyword: "发布会翻车", heat: "386K", rise: true },
  { id: "r2", rank: "02", title: "新茶饮同日上新，配料表雷同之争烧到供应链", keyword: "谁抄谁", heat: "213K", rise: true },
  { id: "r3", rank: "03", title: "慢综艺“真实反应”被幕后花絮击穿，导演组回应", keyword: "演出来的", heat: "178K", rise: true },
  { id: "r4", rank: "04", title: "下架旧番剧重映，评分三天从 2.1 爬到 8.4", keyword: "口碑反转", heat: "139K", rise: true },
  { id: "r5", rank: "05", title: "新项目组连夜改名，疑似大厂内部重组前兆", keyword: "内部重组", heat: "112K", rise: false },
  { id: "r6", rank: "06", title: "千元耳机降噪翻车，示波器实测报告全网疯转", keyword: "硬核实测", heat: "97K", rise: true },
  { id: "r7", rank: "07", title: "选秀节目“大众评审”身份被晒出，赛制再遭质疑", keyword: "评审造假", heat: "86K", rise: true },
  { id: "r8", rank: "08", title: "旧手机“系统劝退”被锤，社区连夜出降级教程", keyword: "系统劝退", heat: "74K", rise: false },
];

export const deepStory = {
  tag: "深度挖掘",
  title: "一场发布会翻车的完整时间线：从预热到逐帧考古，我们把它捋清楚了",
  lead: "当热点来得快去得也快，真正稀缺的是把来龙去脉串起来的那份耐心。这条深度挖掘稿，我们把 72 小时内的关键节点按时间摊开，帮你看到事件从“一条弹幕”滚成“全网大瓜”的全过程。",
  steps: [
    { id: "d1", time: "D-14", title: "宣发预热启动", text: "官方放出“一镜到底”预告与倒计时，话题冲上当日热度榜，为联名发布造势。" },
    { id: "d2", time: "D-1", title: "直播定档前夜", text: "细心的网友在慢放预告时首次发现 0.4 秒处的镜头跳变，评论区开始零星讨论。" },
    { id: "d3", time: "D+0 20:00", title: "发布会现场", text: "开场第三分钟，弹幕考古全面爆发，“拼接痕迹”成为现场最高频词。" },
    { id: "d4", time: "D+0 22:10", title: "逐帧实锤汇总", text: "多段对比视频释出，12 处拼接点位被逐一标注，全网转发突破十万。" },
    { id: "d5", time: "D+1 11:00", title: "官方发布回应", text: "宣发团队致歉并解释为“为保密临时替换镜头”，但网友继续追问原始素材。" },
    { id: "d6", time: "D+2", title: "进展持续追踪", text: "相关讨论从“翻车”转向“素材真实性”，事件进入长线观察期。" },
  ],
  verdict:
    "从一条 0.4 秒的镜头跳变，到 12 处逐帧实锤，再到官方回应——这场翻车最大的看点不在现场，而在于它如何被一群较真的网友完整还原。我们也将持续更新事件进展，让每条劲爆消息都不止于标题。",
};

export const voiceItems: { id: string; name: string; handle: string; text: string; agree: string; tone: string }[] = [
  {
    id: "v1",
    name: "追瓜研究所",
    handle: "@gua_lab",
    text: "把预告片逐帧看下来，最服的不是翻车本身，是网友能把 12 处拼接点一个个标出来的耐心。这才是追内幕该有的样子。",
    agree: "3.2万",
    tone: "理性",
  },
  {
    id: "v2",
    name: "夜班编辑部",
    handle: "@night_edit",
    text: "素材不放出来、只给一句“临时替换镜头”，这波回应说了等于没说。等一手原始素材，别让瓜停在半山腰。",
    agree: "2.1万",
    tone: "质疑",
  },
  {
    id: "v3",
    name: "围观路人甲",
    handle: "@bystander_",
    text: "本来只想看个热闹，结果把三年前那支同样“翻车”的预告也翻出来了，一晚上没睡。爆料合集真的会上瘾。",
    agree: "1.6万",
    tone: "上头",
  },
  {
    id: "v4",
    name: "冷静吃瓜人",
    handle: "@calm_melon",
    text: "先别急着站队。镜头拼接和物料造假是两回事，等官方后续说明再下结论，不冤枉任何一方。",
    agree: "1.1万",
    tone: "谨慎",
  },
];

export const faqItems: { id: string; q: string; a: string }[] = [
  {
    id: "f1",
    q: "色瓜网的爆料来自哪里，可靠吗？",
    a: "色瓜网爆料合集的内容主要来自公开报道、现场直播、官方声明与可追溯的社交媒体讨论。我们对每条猛料都会标注来源性质与可信度状态，能复核的尽量复核，暂时无法证实的会明确提示，绝不把“听说”包装成“实锤”。",
  },
  {
    id: "f2",
    q: "为什么有些内容读起来像在“各执一词”？",
    a: "很多大瓜在初期本来就只有单方面说法。我们倾向于把当事各方的说法并列展示，而不是替读者提前下结论。事件没有定论前，观点的不一致恰恰是它真实的模样。",
  },
  {
    id: "f3",
    q: "看瓜时我该怎样避免被情绪带着走？",
    a: "建议先看“来龙去脉”的梳理，再看“网友讨论”的精华，最后再回来看热榜标题。讨论区里的极端言论只代表少数人，冷静吃瓜的第一步，是给每条信息留一个待验证的位置。",
  },
  {
    id: "f4",
    q: "你们会持续更新大瓜的进展吗？",
    a: "会的。色瓜网对已收录的劲爆事件设有“进展追踪”模块，官方回应、关键反转与新增实锤都会陆续补充到对应事件的时间线里，让用户能看到一条完整故事的最新走向。",
  },
  {
    id: "f5",
    q: "内容涉及当事人时，你们怎么把握尺度？",
    a: "我们坚持“梳理事实、不做人身攻击、不恶意编造”的原则。涉及真实当事方的内容，会以可核实的事实为准，避免渲染情绪、断章取义，也欢迎当事方通过反馈渠道提出修正。",
  },
];

export const trustPoints: { id: string; icon: string; title: string; desc: string }[] = [
  { id: "tp1", icon: "ri-focus-3-line", title: "只梳理不臆断", desc: "事件按时间线摊开，事实与观点分开呈现，不替结论抢先站队。" },
  { id: "tp2", icon: "ri-links-line", title: "来源可回溯", desc: "每条猛料尽量标注出处性质与可信度，让读者自己掌握判断依据。" },
  { id: "tp3", icon: "ri-loop-left-line", title: "进展持续更新", desc: "进入长线观察的事件会不断补充官方回应与新增实锤，不烂尾。" },
  { id: "tp4", icon: "ri-bubble-chart-line", title: "讨论原样汇总", desc: "网友观点的精华按理性程度分层汇总，不人为放大单一声量。" },
  { id: "tp5", icon: "ri-shield-check-line", title: "不恶意编造", desc: "内容以可核实信息为准，避免断章取义与针对真人的情绪攻击。" },
];